import React, { useEffect, useState } from "react";
// import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet ,apiPost} from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
// import NoData from "../component/NoData";
import moment from "moment";
import DateRangeModal from "./DateRangeModal";
import RescueFilter from "./RescueFilter";
import { toast } from "react-toastify";
// import LayoutNew from "../components/shared/LayoutNew";
import { useNavigate } from "react-router-dom";

const RealTimeBonus = () => {
   const navigate = useNavigate();  
  var previousDate = moment().format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
    startDate: previousDate,
    endDate: currentDate,
    limit: "0%",
    range: "today",
  });
  console.log(filter);
  const [tab, setTab] = useState("rebate");
  const getData = async () => {
    const { status, data } = await apiGet(
      apiPath.realTimeBonus + "/" + tab,
      filter,
    );
    if (status == 200) {
      if (data?.success) {
        setData(data?.data);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [filter, tab]);
  const [loading, setLoading] = useState(false);

  const claimBonus = async () => {
    try {
      setLoading(true);

      const { status, data } = await apiPost( apiPath.claimBonus
      );

      if (status === 200 && data?.success) {
       // setData(data.results);
        toast.success(data?.message);
         getData();
      }
    } catch (error) {
      console.error(error);
      toast.error(data?.message);
    } finally {
      setLoading(false);
      toast.error(data?.message);
    }
  };
  // const rebateData = {
  //   title: "Instant Rebate - Slots, Casino, Table, Sports",
  //   totalRebateAmount: "27.13",
  //   totalClaimed: "27.13",
  //   totalExpired: "0",
  //   gameTypes: [
  //     {
  //       name: "Slots",
  //       rebateOpen: true,
  //       items: [
  //         {
  //           vendor: "JILI",
  //           rebate: "0.3%",
  //           totalRebateAmount: "26.23",
  //           totalTurnover: "8,708.00",
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sports",
  //       rebateOpen: true,
  //       items: [
  //         {
  //           vendor: "CRICKET",
  //           rebate: "0.3%",
  //           totalRebateAmount: "0.90",
  //           totalTurnover: "300.00",
  //         },
  //       ],
  //     },
  //   ],
  // };

  // const [mainOpen, setMainOpen] = useState(false);

  // const [gameTypes, setGameTypes] = useState(
  //   rebateData.gameTypes.map((item) => ({
  //     ...item,
  //     isOpen: true,
  //   })),
  // );

  // const toggleGameType = (index) => {
  //   setGameTypes((prev) =>
  //     prev.map((item, i) =>
  //       i === index ? { ...item, isOpen: !item.isOpen } : item,
  //     ),
  //   );
  // };
console.log(data,"---------")
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="reward-center-container">
        <div className="reward-center">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-rewardCenter mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => navigate(-1)}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg className="am-icon am-icon-left am-icon-lg">
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div style={{ color: "white" }} className="am-navbar-title">
                User Loss Bonus
              </div>
              <div className="am-navbar-right" />
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>
       
          <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c2794537353
          className="ng-tns-c2794537353-13 ng-star-inserted"
        >
          {/* <div
            _ngcontent-serverapp-c2794537353
            className="player-top ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="tab-btn-section ng-tns-c2794537353-13"
            >
              <app-tab-button-nav
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
                _nghost-serverapp-c1328719065
              >
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn tab-btn-page"
                >
                  <div
                    _ngcontent-serverapp-c1328719065
                    className="line"
                    style={{
                      width: "calc(50%)",
                      "-webkit-transform": "translate(0%, 0px)",
                      "-ms-transform": "translate(0%, 0px)",
                      transform: "translate(0%, 0px)",
                    }}
                  />
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted active"
                    data-tab-current="current"
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Rebate")}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted"
                    data-tab-current
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Rescue")}
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn-page-underline"
                />
              </app-tab-button-nav>
            </div>
          </div> */}

          <div
            _ngcontent-serverapp-c514414220
            className="tab-content tab-content-page"
          >
            <router-outlet _ngcontent-serverapp-c1266201197 />
            <ng-component className="ng-star-inserted">
              <div className="real-time-bonus-wrap ng-star-inserted">
                <div className="menu-box available-amount">
                  <div
                    className="available-amount__bg"
                    style={{
                      "background-image":
                        'url("/assets/NewImages/bg-available-amount.webp?v=1776751585885")',
                    }}
                  />
                  <div className="available-amount__title">
                    <div
                      className="available-amount__icon"
                      style={{
                        "mask-image":
                          'url("/assets/NewImages/icon-available-amount.webp?v=1776751585885")',
                      }}
                    />
                    <div className="available-amount__text">
                      {" "}
                      {t("AvailableAmount")}{" "}
                    </div>
                  </div>
                  <div
                    className="available-amount__decor"
                    style={{
                      "background-image":
                        'url("/assets/NewImages/deco-available-amount.webp?v=1776751585885")',
                    }}
                  />
                  <div className="available-amount__value">
                    {" "}
                    ৳{data?.availableAmount || 0}{" "}
                  </div>

                  <div className="button available-amount__button ng-star-inserted">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (!loading) {
                          claimBonus();
                        }
                      }}
                      style={{
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.6 : 1,
                      }}
                    >
                      {loading ? (
                        <span className="spinner"></span>
                      ) : (
                        t("ClaimBonus")
                      )}
                    </a>
                  </div>
                </div>
                <div className="menu-box">
                  <div className="claimed-box">
                    <div className="claimed-box__item">
                      <div className="claimed-box__title">
                        {t("ClaimedToday")}
                      </div>
                      <div className="claimed-box__value">
                        {" "}
                        ৳{data?.claimedToday || 0}{" "}
                      </div>
                    </div>
                    <div className="claimed-box__item">
                      <div className="claimed-box__title">
                        {" "}
                        {filter?.range == "today"
                          ? "This Week"
                          : filter?.range == "Optional Date"
                            ? `${filter?.startDate} - ${filter?.endDate}`
                            : filter?.range}
                      </div>
                      <div className="claimed-box__value">
                        {" "}
                        ৳{data?.claimedThisWeek || 0}{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="menu-box">
                  {/* <div className="bonus-summary-box">
                    <div className="bonus-summary__title">
                      <h2>
                        <span>{t("Summary")}</span>
                      </h2>
                    </div>
                  </div> */}
                  {/* <RescueFilter
                    setFilter={setFilter}
                    filter={filter}
                    getData={getData}
                    setShow={setShow}
                    show={show}
                  /> */}
                  {/* {gameTypes.length > 0 ? (
                    <ul className="bonus-summary__group">
                      <li
                        className={`accordion-wrap real-time-bonuses-accordion ${
                          mainOpen ? "accordion-wrap--expanded" : ""
                        }`}
                      >
                        <div
                          className="accordion-header"
                          onClick={() => setMainOpen(!mainOpen)}
                        >
                          <div className="accordion-header__main-info">
                            <h4 className="accordion-header__title">
                              {rebateData.title}
                            </h4>

                            <span
                              className={`accordion-header__arrow ${
                                mainOpen ? "rotate" : ""
                              }`}
                              style={{
                                maskImage:
                                  'url("https://img.b426b.com/bb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1780386069091")',
                              }}
                            ></span>
                          </div>

                          <div className="accordion-header__total-amount-info">
                            <div className="total-rebate">
                              <span className="total-rebate__title">
                                Total Rebate Amount
                              </span>
                              <span className="total-rebate__value">
                                {rebateData.totalRebateAmount}
                              </span>
                            </div>

                            <div className="total-claimed">
                              <span className="total-claimed__title">
                                Total Claimed
                              </span>
                              <span className="total-claimed__value">
                                {rebateData.totalClaimed}
                              </span>
                            </div>

                            <div className="total-expired">
                              <span className="total-expired__title">
                                Total Expired
                              </span>
                              <span className="total-expired__value">
                                {rebateData.totalExpired}
                              </span>
                            </div>
                          </div>
                        </div>

                        {mainOpen && (
                          <ul className="accordion-collapse">
                            {gameTypes.map((gameType, index) => (
                              <li
                                key={gameType.name}
                                className={`accordion-collapse__item ${
                                  gameType.isOpen
                                    ? "accordion-wrap--expanded"
                                    : ""
                                }`}
                              >
                                <div
                                  className="game-type-accordion-header"
                                  onClick={() => toggleGameType(index)}
                                >
                                  <h4>{gameType.name}</h4>

                                  <span
                                    className={`game-type-accordion-header__button ${
                                      gameType.isOpen ? "rotate" : ""
                                    }`}
                                    style={{
                                      "--icon-expand":
                                        "url('https://img.b426b.com/bb/h5/assets/images/icon-set/icon-expand.svg?v=1780386069091')",
                                      "--icon-collapse":
                                        "url('https://img.b426b.com/bb/h5/assets/images/icon-set/icon-collapse.svg?v=1780386069091')",
                                    }}
                                  >
                               
                                  </span>
                                </div>

                                {gameType.isOpen && (
                                  <ul className="game-type-accordion-collapse">
                                    {gameType.items.map((item, itemIndex) => (
                                      <li
                                        key={itemIndex}
                                        className="game-type-accordion-collapse__item"
                                      >
                                        <div className="game-type-title">
                                          <span className="vendor-name">
                                            {item.vendor}
                                          </span>

                                          <div className="rebate-pct">
                                            <span>Rebate</span>
                                            <span>{item.rebate}</span>
                                          </div>
                                        </div>

                                        <div className="game-type-detail">
                                          <div className="total-rebate-amount">
                                            <span>Total Rebate Amount</span>
                                            <span className="numeric">
                                              {item.totalRebateAmount}
                                            </span>
                                          </div>

                                          <div className="total-turnover">
                                            <span>Total Turnover</span>
                                            <span className="numeric">
                                              {item.totalTurnover}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    </ul>
                  ) : ( */}
                  {/* <mcd-no-data
                    _nghost-serverapp-c3013389467
                    className="ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c3013389467
                      className="no-result"
                    >
                      <div _ngcontent-serverapp-c3013389467 className="pic">
                        <img
                          _ngcontent-serverapp-c3013389467
                          alt="no-data"
                          src="/assets/NewImages/no-data.webp?v=1776751585885&source=mcdsrc"
                          loading="lazy"
                        />
                      </div>
                      <div
                        _ngcontent-serverapp-c3013389467
                        className="text ng-star-inserted"
                      >
                        {" "}
                        {t("NoData")}{" "}
                      </div>
                    </div>
                  </mcd-no-data> */}
                  {/* )} */}
                </div>
              </div>
            </ng-component>
          </div>
        </ng-component>
      </ng-component>
      {show && (
        <DateRangeModal
          show={show}
          setShow={setShow}
          filter={filter}
          setFilter={setFilter}
        />
      )}
        </div>
      </div>
    </div>
  );
};

export default RealTimeBonus;
